import { createAction } from "redux-actions";

const SET_REFERENCE_TAB = "REFERENCES/set_reference_tab";
const EMPTY_REFERENCE_TAB = "REFERENCES/empty_reference_tab";

export const setReferenceTab = createAction(SET_REFERENCE_TAB);
export const emptyReferenceTab = createAction(EMPTY_REFERENCE_TAB);
